import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

function AbaGestaoLocais({ somenteConsulta = false }) {
  const [locais, setLocais] = useState([]);
  const [nome, setNome] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [editandoId, setEditandoId] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregarLocais = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, 'locais'), orderBy('nome', 'asc'));
      const snap = await getDocs(q);
      setLocais(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error('Erro ao carregar locais:', e);
    }
    setLoading(false);
  };

  useEffect(() => {
    carregarLocais();
  }, []);

  const salvarLocal = async (e) => {
    e.preventDefault();
    if (!nome || !cidade || !estado) {
      alert('Por favor, preencha todos os campos: nome, cidade e estado.');
      return;
    }

    setLoading(true);
    try {
      if (editandoId) {
        await updateDoc(doc(db, 'locais', editandoId), { nome, cidade, estado });
        alert('Local atualizado com sucesso.');
      } else {
        await addDoc(collection(db, 'locais'), { nome, cidade, estado });
        alert('Novo local cadastrado com sucesso.');
      }

      cancelarEdicao();
      carregarLocais();
    } catch (e) {
      console.error('Erro ao salvar local:', e);
      alert('Erro ao gravar os dados.');
    }
    setLoading(false);
  };

  const prepararEdicao = (local) => {
    setEditandoId(local.id);
    setNome(local.nome || '');
    setCidade(local.cidade || '');
    setEstado(local.estado || '');
  };

  const cancelarEdicao = () => {
    setEditandoId(null);
    setNome('');
    setCidade('');
    setEstado('');
  };

  const excluirLocal = async (id, nomeLocal) => {
    if (window.confirm(`Tem certeza que deseja excluir o local "${nomeLocal}" do cadastro?`)) {
      try {
        await deleteDoc(doc(db, 'locais', id));
        carregarLocais();
      } catch (e) {
        console.error('Erro ao excluir local:', e);
        alert('Erro ao excluir o local.');
      }
    }
  };

  return (
    <div className="routine-panel">
      <form
        onSubmit={salvarLocal}
        className={`routine-form-surface routine-surface ${editandoId ? 'is-highlighted' : ''}`}
      >
        {editandoId && !somenteConsulta && (
          <div className="routine-form-banner">
            Editando o cadastro selecionado. Salve as alterações ou cancele para voltar ao modo de inclusão.
          </div>
        )}

        <div className="routine-field routine-field--grow">
          <label className="routine-label">Nome do local</label>
          <input
            type="text"
            placeholder="Ex: Loja Matriz"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="routine-input"
            disabled={somenteConsulta}
          />
        </div>

        <div className="routine-field">
          <label className="routine-label">Cidade</label>
          <input
            type="text"
            placeholder="Ex: Rio do Sul"
            value={cidade}
            onChange={(e) => setCidade(e.target.value)}
            className="routine-input"
            disabled={somenteConsulta}
          />
        </div>

        <div className="routine-field">
          <label className="routine-label">UF</label>
          <input
            type="text"
            placeholder="SC"
            value={estado}
            onChange={(e) => setEstado(e.target.value.toUpperCase())}
            maxLength={2}
            className="routine-input"
            disabled={somenteConsulta}
          />
        </div>

        <div className="routine-actions">
          <button type="submit" disabled={somenteConsulta || loading} className="routine-btn routine-btn--primary">
            {loading ? 'Processando...' : editandoId ? 'Salvar alterações' : 'Incluir local'}
          </button>

          {editandoId && !somenteConsulta && (
            <button type="button" onClick={cancelarEdicao} className="routine-btn routine-btn--soft">
              Cancelar
            </button>
          )}
        </div>
      </form>

      {loading && locais.length === 0 ? (
        <div className="routine-empty">Carregando locais cadastrados...</div>
      ) : (
        <div className="routine-table-wrap">
          <table className="routine-table">
            <thead>
              <tr>
                <th>Nome do local</th>
                <th>Cidade</th>
                <th>UF</th>
                <th style={{ width: '220px', textAlign: 'center' }}>{somenteConsulta ? 'Consulta' : 'Ações'}</th>
              </tr>
            </thead>
            <tbody>
              {locais.map((local) => (
                <tr key={local.id}>
                  <td><strong>{local.nome}</strong></td>
                  <td>{local.cidade}</td>
                  <td>{local.estado}</td>
                  <td>
                    {somenteConsulta ? (
                      <span className="routine-section-subtitle" style={{ margin: 0 }}>
                        Consulta liberada
                      </span>
                    ) : (
                      <div className="admin-actions-row">
                        <button type="button" className="routine-btn routine-btn--soft" onClick={() => prepararEdicao(local)}>
                          Editar
                        </button>
                        <button type="button" className="routine-btn routine-btn--danger" onClick={() => excluirLocal(local.id, local.nome)}>
                          Excluir
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}

              {locais.length === 0 && (
                <tr>
                  <td colSpan="4" className="routine-empty">
                    Nenhum local cadastrado até o momento.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AbaGestaoLocais;
